import script from "./KitchenDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./KitchenDetail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__